import React, { memo } from 'react';
import PropTypes from 'prop-types';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import CardImage from '../Views/CardImage';
import { vocabTitle } from '../../../helpers/content';

const FlexRobotCard = memo(({ item, compact, hideLink, gridLayout }) => {
  const yearLabel = vocabTitle(item.robot_year);

  const titleBlock = (
    <>
      {yearLabel && <h6 className="cards__subtitle">{yearLabel}</h6>}
      <h4 className="cards__title">{item.title ? item.title : item.id}</h4>
    </>
  );

  return (
    <div
      className={`cards__item ${gridLayout ? 'cards__item--grid' : 'cards__item--fullwidth'}`}
    >
      {!compact && (
        <CardImage
          item={item}
          fallback={'/robot_default_image.svg'}
          gridLayout={gridLayout}
          href={hideLink ? undefined : item['@id']}
        />
      )}
      <div className="cards__content">
        {hideLink ? (
          titleBlock
        ) : (
          <UniversalLink href={item['@id']}>{titleBlock}</UniversalLink>
        )}
        {item.description && (
          <p className="cards__description">{item.description}</p>
        )}
      </div>
    </div>
  );
});

FlexRobotCard.displayName = 'FlexRobotCard';

FlexRobotCard.propTypes = {
  item: PropTypes.shape({
    '@id': PropTypes.string.isRequired,
    title: PropTypes.string,
    id: PropTypes.string,
    description: PropTypes.string,
    robot_year: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({ title: PropTypes.string }),
    ]),
    is_active: PropTypes.bool,
    image_caption: PropTypes.string,
  }).isRequired,
  compact: PropTypes.bool,
  hideLink: PropTypes.bool,
  gridLayout: PropTypes.bool,
};

export default FlexRobotCard;
